const logic_field_instance_comp = {
  props: {
    logic: {
      type: Object,
      default: function() {
        return null;
      }
    },
    field: {
      type: Object,
      required: true
    },
    controlableFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    possibleFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    logicalFields: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  render: function(h) {
    return h(this._getComponent(), {
      props: {
        logic: this.logic,
        field: this.field,
        controlableFields: this.controlableFields,
        possibleFields: this.possibleFields
      },
      ref: 'instance',
      on: {
        updateSetting: this.updateSetting,
        validChanged: this.emitValidChange,
        editingChanged: this.changeEditingStatus
      }
    });
  },

  methods: {
    enableEditIfNeed: function(event) {
      this.$refs.instance.enableEditIfNeed(event);
    },

    updateSetting: function(setting, field) {
      this.$emit('updateSetting', setting, field);
    },

    emitValidChange: function(value) {
      this.$emit('validChanged', value);
    },

    changeEditingStatus: function(status) {
      this.$emit('editingChanged', status);
    },

    clearInvalidLogic: function() {
      this.$refs.instance.clearInvalidLogic();
    },

    _getComponent: function() {
      var type;

      type = this.field.type.demodulize();
      return this.logicalFields[`Logical${type}`] || this.logicalFields.LogicalTextField;
    },

    isValid: function() {
      return this.$refs.instance.isValid();
    },

    displayError: function() {
      return this.$refs.instance.displayError();
    }
  }
};

const logic_field_comp = {
  props: {
    logic: {
      type: Object,
      default: function() {
        return null;
      }
    },
    field: {
      type: Object,
      required: true
    },
    logicalFields: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  components: {
    'field-instance': logic_field_instance_comp
  },

  data: function() {
    return {
      editing: false,
      valid: true
    };
  },

  template: `
    <div class="logic-field-item form-field"
         :class='[requiredClass, { editing: editing, invalid: !valid, "has-error": !valid }]'
         @click='enableEditIfNeed'>
      <div class="form-field-head">
        <div class="form-field-title vertical-middle">
          <div class="chip identifier right" :class='statusClass' data-title='不可设置逻辑属性'>
            <span v-if='field.detail_id'>Q{{ field.detail.position + 1 }} - {{ field.position + 1 }}</span>
            <span v-else>Q{{ field.position + 1 }}</span>
          </div>
          <span>{{ field.title }}</span>
        </div>
        <div class="form-field-description" v-if='field.description' v-html='field.description'></div>
      </div>
      <div class="form-field-input-container">
        <field-instance :field='field'
                        :logic='logic'
                        :controlableFields='controlableFields'
                        :possibleFields='possibleFields'
                        :logicalFields='logicalFields'
                        ref='field'
                        @editingChanged='changeEditingStatus'
                        @validChanged='updateValid'
                        @updateSetting='updateSetting' />
        <div class="message" v-show='!valid'>
          <span>此字段的逻辑属性失效</span>
          <span v-if='!controlableFields.length'>，因为之后没有能控制的字段，无法设置逻辑属性</span>
          <span class="link-style error-link" @click='clearInvalidLogic'>清除失效逻辑</span>
        </div>
      </div>
    </div>
  `,

  computed: {
    requiredClass: function() {
      return {
        required: _.contains(this.field.validations, 'presence')
      };
    },

    logicable: function() {
      return this.field.logicable && Boolean(this.controlableFields.length);
    },

    statusClass: function() {
      return {
        'slp-tooltip': !this.logicable,
        'darken-organge': this.logicable
      };
    },

    controlableFields: function() {
      return _.filter(this.$parent.fields.slice(this.field.position + 1), (field) => field.type !== 'Field::Page');
    },

    possibleFields: function() {
      return this.$parent.fields;
    }
  },

  methods: {
    enableEditIfNeed: function(event) {
      this.$refs.field.enableEditIfNeed(event);
    },

    clearInvalidLogic: function() {
      this.$refs.field.clearInvalidLogic();
    },

    changeEditingStatus: function(status) {
      this.editing = status;
    },

    updateSetting: function(setting, field) {
      this.$emit('updateSetting', setting, field);
    },

    updateValid: function(value) {
      this.valid = value;
    },

    isValid: function() {
      return this.$refs.field.isValid();
    },

    displayError: function() {
      if (this.field.type === 'Field::Detail') {
        return this.$refs.field.displayError();
      } else {
        return this.$el.scrollIntoView();
      }
    }
  }
};

const LogicFieldListMixin = {
  props: {
    fields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    logic_settings: {
      type: Object,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    inDetail: {
      type: Boolean,
      default: false
    },
    logicalFields: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  data: function() {
    return {
      logics: this.logic_settings
    };
  },

  components: {
    field: logic_field_comp
  },

  template: `
    <div class="logic-field-list" :class='customClass'>
      <field v-for='field in fields'
             :key='field.id'
             :logic='logics'
             :field='field'
             :logicalFields='logicalFields'
             ref='fields'
             @updateSetting='updateSetting' />
    </div>
  `,

  methods: {
    updateSetting: function(setting, field) {
      if (this.inDetail) {
        this.$emit('updateSetting', setting, field);
      } else {
        if (_.isEmpty(setting)) {
          delete this.logics[field.id];
        } else {
          Vue.set(this.logics, field.id, setting);
        }
        this.$emit('updateSetting', this.logics, field);
      }
    },

    isValid: function() {
      return _.every(this.$refs.fields, (field) => field.isValid());
    },

    displayError: function() {
      var fieldView, i, len, ref;

      ref = this.$refs.fields;
      for (i = 0, len = ref.length; i < len; i++) {
        fieldView = ref[i];
        if (!fieldView.isValid()) {
          fieldView.displayError();
          break;
        }
      }
    }
  }
};

export default LogicFieldListMixin;
